const progItem = {
  bindings: {
    data: '<',
    consist: '<',
  },
  templateUrl: '/modules/configurationManagement/train-management/content-area/prog-item/prog-item.html',
  controller: 'ProgItemController',
};

angular
  .module('configuration-management.module')
  .component('progItem', progItem);